import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Container } from "reactstrap";
import CategoriesSection from "../components/CategoriesSection";
import Menus from "../components/Menus";
import { getMenuCategories, getMenuItems } from "../store/actions/MenuActions";
import {
  getCatalogsAction,
  getRestaurantsAction,
} from "../store/actions/restaurantsAction";
import {
  clearCartAction,
  clearCartDetails,
} from "../store/actions/cartAction";
import HeroSection from "./heroSection";
import CatalogSection from "../components/CatalogSection";
import { toast } from "react-toastify";

const AdminView = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { cartDetails } = useSelector((state) => state.cart);
  const { menuCategories, menuItems, categoriesLoading } = useSelector(
    (state) => state.parentMenu
  );
  const { catalogs } = useSelector((state) => state.restaurants);
  const [activeTab, setActiveTab] = useState("");
  const restaurantID = cartDetails?.restaurantId;

  useEffect(() => {
    if (!restaurantID) {
      dispatch(clearCartAction());
      dispatch(clearCartDetails());
      toast.warning("Please select restaurant to view detail");
      history.push("/restaurants");
      return;
    }
    if (cartDetails?.menuId) {
      dispatch(getMenuCategories(cartDetails?.menuId));
      dispatch(getRestaurantsAction(restaurantID));
      dispatch(getCatalogsAction(restaurantID));
    }
  }, [dispatch, cartDetails, restaurantID, history]);

  useEffect(() => {
    if (menuCategories?.length > 0) {
      const firstCategory = menuCategories[0];
      setActiveTab(firstCategory);
    }
  }, [menuCategories]);

  useEffect(() => {
    if (restaurantID && activeTab) {
      dispatch(getMenuItems(restaurantID, activeTab?.id));
    }
  }, [restaurantID, activeTab, dispatch]);

  return (
    <>
      <Container className="product_details" style={{ minHeight: "80vh" }}>
        <HeroSection />

        <CatalogSection catalogs={catalogs} />

        <CategoriesSection
          categories={menuCategories}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          categoriesLoading={categoriesLoading}
        />

        {activeTab && <Menus menuItems={menuItems} categoryId={activeTab} />}
      </Container>
    </>
  );
};

export default AdminView;
